import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../common/commonService";
import { urlConstant } from "../../constant/urlConstant";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { forkJoin } from "rxjs";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-invoice-performa",
  templateUrl: "./invoice-performa.component.html",
  styleUrls: ["./invoice-performa.component.scss"],
})
export class InvoicePerformaComponent implements OnInit {
  loginUserDetail: any;
  selectedCity: string = "";
  selectedTypeStatus: string = "";
  searchText: string = "";
  selectedBHK = null;
  bhkList: any = [{ id: "Select BHK" }];
  cities: any = [];
  statuses: any = [];
  propertyData: any;
  propertyDataBackup: any;
  loading: Boolean;
  managers: any[] = [];
  selectedName: string = "";
  latestTicketNumber = "";
  latestPropertyName = "";
  latestPropertyId = "";
  private modalRef: NgbModalRef | undefined;

  @ViewChild("latestInvoiceModal", { static: false })
  latestInvoiceModal: TemplateRef<any>;
  constructor(
    public toasterService: ToasterService,
    public route: ActivatedRoute,
    public router: Router,
    public _CommonService: CommonService,
    private modalService: NgbModal
  ) {
    this.loginUserDetail = this._CommonService.getLoggedInUser();
    this.selectedBHK = this.bhkList[0];
  }

  ngOnInit() {
    this._CommonService.showLoading();
    if (
      this.loginUserDetail.roleId === 222 ||
      this.loginUserDetail.roleId === 444
    ) {
      this.getAllPropertyByModule();
      if (this.loginUserDetail.roleId === 444) {
        this.getPropertyManagers();
      }
    } else {
      this.getAllProperty(this.loginUserDetail.userId);
    }
  }

  latestProperty: any;
  latestInvoice: any;
  getLatestInvoice() {
    this._CommonService
      .get<any>(urlConstant.ProformaInvoice.getLatestProformaInvoice)
      .subscribe((res) => {
        if (res != null) {
          console.log(res);
          this.latestInvoice = res.data.ProformaInvoice;
          this.latestTicketNumber = res.data.ProformaInvoice.proformainvoiceNo;
          this.latestPropertyId = res.data.ProformaInvoice.propertyId;
        }
        this.latestProperty = this.propertyData.find(
          (property) => property.propertyId === this.latestPropertyId
        );
        this.latestPropertyName = this.latestProperty.propertyName;
      });
  }

  getAllProperty(userId) {
    this._CommonService.showLoading();
    this._CommonService
      .get<any>(urlConstant.Property.ByUserId + "?userId=" + userId)
      .subscribe(
        (res) => {
          if (res.Status === "200") {
            console.log(res);
            this.propertyData = res.data.Property;
            this.propertyDataBackup = this.propertyData;
            this.propertyData.sort(
              (a, b) =>
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime()
            );
            if (res.data.bhkList) {
              res.data.bhkList.map((bhk) => {
                this.bhkList.push({ id: bhk });
              });
            }
            this.cities = [];
            this.statuses = [];
            for (let p of this.propertyData) {
              if (this.cities.indexOf(p.city) == -1) {
                this.cities.push(p.city);
              }

              if (p.type && p.type.id) {
                let obj = this.statuses.find((o) => o.id == p.type.id);
                if (!obj) {
                  this.statuses.push(p.type);
                }
              }
            }
            this.getLatestInvoice();
          }
          this._CommonService.hideLoading();
        },
        (error) => {
          if (error != null) {
            this.toasterService.pop("error", "Error", error.message);
          }
          this._CommonService.hideLoading();
        }
      );
  }

  gotoInvoiceDetailAdd(property: any) {
    this.router.navigate([
      `/admin/invoice-performa/add-view-invoice/${property.propertyId}`,
    ]);
  }

  clearFilter() {
    this.selectedCity = "";
    this.selectedTypeStatus = "";
    this.searchText = "";
    this.selectedBHK = this.bhkList[0];
    this.selectedName = "";
    this.filter("", "", "", this.bhkList[0], "");
    this.propertyDataBackup = this.propertyData;
  }

  textChange(searchText) {
    this.filter(
      this.selectedCity,
      this.selectedTypeStatus,
      searchText,
      this.selectedBHK,
      this.selectedName
    );
  }

  onChangeCity(selectedCity) {
    this.selectedCity = selectedCity;
    this.filter(
      selectedCity,
      this.selectedTypeStatus,
      this.searchText,
      this.selectedBHK,
      this.selectedName
    );
  }

  onChangeStasus(selectedTypeStatus) {
    this.selectedTypeStatus = selectedTypeStatus;
    this.filter(
      this.selectedCity,
      selectedTypeStatus,
      this.searchText,
      this.selectedBHK,
      this.selectedName
    );
  }
  onChangeBHK(selectedBHK) {
    this.selectedBHK = selectedBHK;
    this.filter(
      this.selectedCity,
      this.selectedTypeStatus,
      this.searchText,
      selectedBHK,
      this.selectedName
    );
  }
  onChangeName(selectedName) {
    this.selectedName = selectedName;
    this.filter(
      this.selectedCity,
      this.selectedTypeStatus,
      this.searchText,
      this.selectedBHK,
      selectedName
    );
  }

  filter(
    selectedCity: String,
    selectedTypeStatus: String,
    searchText: String,
    selectedBHK: any,
    selectedName: String
  ) {
    this.propertyData = this.propertyDataBackup;
    this.propertyData = this.propertyData
      .filter((el) => {
        if (!!selectedTypeStatus) {
          return !!el.type && selectedTypeStatus === el.type.id;
        }
        return true;
      })
      .filter((el) => {
        if (!!selectedCity) {
          return selectedCity === el.city;
        }
        return true;
      })
      .filter((el) => {
        if (searchText) {
          return (
            el.propertyName.toLowerCase().indexOf(searchText.toLowerCase()) !==
            -1
          );
        }
        return true;
      })
      .filter((el) => {
        if (selectedBHK && selectedBHK.id !== "Select BHK") {
          return !!el.bhk && el.bhk === selectedBHK.id;
        }
        return true;
      })
      .filter((el) => {
        if (selectedName) {
          return el.user.id === selectedName;
        }
        return true;
      });
  }

  getAllPropertyByModule() {
    this._CommonService
      .get<any>(urlConstant.Common.getAllPropertyForModules + "?module=Invoice")
      .subscribe(
        (res: any) => {
          console.log("Property List getAllPropertyByModule:", res);
          if (res.Status === "200") {
            this.propertyData = res.data.Property;
            this.propertyDataBackup = this.propertyData;

            if (res.data.bhkList) {
              res.data.bhkList.map((bhk) => {
                this.bhkList.push({ id: bhk });
              });
            }
            this.cities = [];
            this.statuses = [];
            for (let p of this.propertyData) {
              if (this.cities.indexOf(p.city) == -1) {
                this.cities.push(p.city);
              }

              if (p.type && p.type.id) {
                let obj = this.statuses.find((o) => o.id == p.type.id);
                if (!obj) {
                  this.statuses.push(p.type);
                }
              }
            }
            this.getLatestInvoice();
            this._CommonService.hideLoading();
          } else {
            this._CommonService.hideLoading();
          }
        },
        (error) => {
          if (error != null) {
            this.toasterService.pop("error", "Error", error.message);
          }
          this._CommonService.hideLoading();
        }
      );
  }

  getPropertyManagers() {
    this.loading = true;
    const req = [
      this._CommonService
        .get<any>(`${urlConstant.DashBoard.getAllManager}`)
        .map((res) => this.getPropertyManagersHandler(res)),
    ];
    forkJoin(req).subscribe(
      (responses) => {
        this.loading = false;
        this._CommonService.hideLoading();
      },
      (error) => {
        this.loading = false;
        this._CommonService.hideLoading();
        if (error != null) {
        }
      }
    );
  }

  getPropertyManagersHandler(res) {
    if (res.data.managers) {
      this.managers = res.data.managers;
    }
  }

  openModal() {
    this.modalRef = this.modalService.open(this.latestInvoiceModal);
  }

  openTicket() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = undefined;
    }
    this.router.navigate([
      `/admin/invoice-performa/add-view-invoice/${this.latestPropertyId}`,
    ]);
  }
}
